import { BarChart, Bar, LineChart, Line, AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from "recharts";
import { FONTS, COLORS } from "../constants/theme";

// ─── SupportIQ ───────────────────────────────────────────────────────────────────
// Persona: Support Director
// Data sources: See constants/modules.js

const KPIs = [
  { label: "CSAT Score", value: "4.6/5", delta: "+0.3 QoQ", color: "#059669" },
  { label: "Tickets (MTD)", value: "1,240", delta: "-8% MoM", color: "#059669" },
  { label: "First Response", value: "18 min", delta: "Target: <30m", color: "#059669" },
  { label: "Avg Resolution", value: "4.2 hrs", delta: "-1.1 hrs QoQ", color: "#059669" },
  { label: "Escalation Rate", value: "3.2%", delta: "-0.8pts", color: "#059669" },
  { label: "FCR Rate", value: "61%", delta: "+4pts QoQ", color: "#059669" }
];
const CHART_DATA = [
  {
    "category": "Onboarding",
    "tickets": 312,
    "csat": 4.2
  },
  {
    "category": "Integration",
    "tickets": 284,
    "csat": 4.1
  },
  {
    "category": "Billing",
    "tickets": 198,
    "csat": 4.7
  },
  {
    "category": "Bug Report",
    "tickets": 241,
    "csat": 3.8
  },
  {
    "category": "Feature Req",
    "tickets": 128,
    "csat": 4.5
  },
  {
    "category": "Other",
    "tickets": 77,
    "csat": 4.6
  }
];

export default function SupportIQ({ module: mod, theme }) {
  const { surface, border, text, muted, dark } = theme;

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>

      {/* KPI Grid */}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 12 }}>
        {KPIs.map((k, i) => (
          <div key={i} style={{ background: surface, border: `1px solid ${border}`, borderRadius: 12, padding: "16px 18px", position: "relative", overflow: "hidden" }}>
            <div style={{ position: "absolute", top: 0, left: 0, right: 0, height: 2, background: `linear-gradient(90deg, ${mod.accent}55, ${mod.accent})` }} />
            <p style={{ color: muted, fontSize: 10, fontFamily: FONTS.mono, letterSpacing: ".08em", textTransform: "uppercase", marginBottom: 6 }}>{k.label}</p>
            <p style={{ fontFamily: FONTS.display, fontWeight: 800, fontSize: 22, color: text, letterSpacing: "-.02em" }}>{k.value}</p>
            <span style={{ display: "inline-block", marginTop: 6, fontFamily: FONTS.mono, fontSize: 10, padding: "2px 7px", borderRadius: 20, color: k.color, background: k.color + "18" }}>{k.delta}</span>
          </div>
        ))}
      </div>

      {/* Chart */}
      <div style={{ background: surface, border: `1px solid ${border}`, borderRadius: 14, padding: "20px 24px" }}>
        <p style={{ fontFamily: FONTS.mono, fontSize: 11, color: muted, letterSpacing: ".08em", textTransform: "uppercase", marginBottom: 16 }}>Ticket Volume by Category</p>
        <ResponsiveContainer width="100%" height={240}>
          <BarChart data={CHART_DATA} barGap={4}>
          <CartesianGrid strokeDasharray="3 3" stroke="#1e243860" />
          <XAxis dataKey="category" tick={{ fill: "#8892b0", fontSize: 11 }} />
          <YAxis tick={{ fill: "#8892b0", fontSize: 11 }} />
          <Tooltip contentStyle={{ background: "#0a0e1a", border: "1px solid #1e2438", borderRadius: 8, fontSize: 11 }} />
          <Legend wrapperStyle={{ fontSize: 11, color: "#8892b0" }} />
          <Bar dataKey="tickets" fill="#e11d48" radius={[4,4,0,0]} />
          <Bar dataKey="csat" fill="#0891b2" radius={[4,4,0,0]} />
        </BarChart>
        </ResponsiveContainer>
      </div>

      {/* Insight */}
      <div style={{ background: mod.accent + "10", border: `1px solid ${mod.accent}25`, borderRadius: 12, padding: "14px 18px", display: "flex", gap: 12, alignItems: "flex-start" }}>
        <span style={{ color: mod.accent, fontSize: 16, flexShrink: 0, marginTop: 1 }}>◉</span>
        <div>
          <p style={{ fontFamily: FONTS.mono, fontSize: 10, color: mod.accent, letterSpacing: ".08em", textTransform: "uppercase", marginBottom: 4 }}>IQ INSIGHT</p>
          <p style={{ fontSize: 13, color: dark ? "#a0aec0" : "#475569", lineHeight: 1.65 }}>Integration tickets have the lowest CSAT (4.1) — likely tied to Salesforce connector friction flagged in Q1. Onboarding volume suggests documentation gaps.</p>
        </div>
      </div>
    </div>
  );
}
